<template>
    <div class="row border-bottom pt-3 pb-3">
        <div class="col-12">
            <span class="text-primary">{{created_at}}</span><br>
            <span class="text-muted">Действие:</span> {{action}} <span>{{log.type_reason === 'system' ? 'системой' : 'пользователем'}}</span><br>
            <span class="text-muted">Инициировал:</span> <span> {{log.saver ? log.saver.name : '—'}}</span>
        </div>
        <div class="col-12 mt-3" v-if="show_params.length">
            <table class="table table-hover table-sm">
                <thead>
                <tr>
                    <th>Параметр</th>
                    <th>Было</th>
                    <th>Стало</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in show_params" :key="p.field">
                    <td>{{p.field}}</td>
                    <td>{{['phone', 'phone2', 'phone3', 'phone4', 'phone5', 'phone6'].includes(p.field) ? $hidePartPhone(p.old) : p.old}}</td>
                    <td>{{['phone', 'phone2', 'phone3', 'phone4', 'phone5', 'phone6'].includes(p.field) ? $hidePartPhone(p.new) : p.new}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['log'],
        name: "RequestHistoryLogItem",
        data: () => ({
            show_params: [],
        }),
        computed: {
            action() {
                switch (this.log.action) {
                    case "show": return "Просмотр";
                    case "create": return "Создание";
                    case "update": return "Изменение";
                    case "delete": return "Удаление";
                }
            },
            created_at() {
                return moment(this.log.created_at).format('DD.MM.YYYY HH:mm:ss');
            }
        },
        mounted() {
            this.makeShowParams();
        },
        methods: {
            makeShowParams() {
                let params = [];
                for (const [key, value] of Object.entries(this.log.fields)) {
                    params.push({field: key, old: value.old, new: value.new});
                }
                this.show_params = params;
            }
        }
    }
</script>

<style scoped>

</style>
